import { render } from "./A104000.vue?vue&type=template&id=81d42266&scoped=true"
import script from "./A104000.vue?vue&type=script&lang=js"
export * from "./A104000.vue?vue&type=script&lang=js"

import "./A104000.vue?vue&type=style&index=0&id=81d42266&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81d42266"]])

export default __exports__